// import router from "@/routers/index";
// import { ROUTER_WHITE_LIST } from "@/config";
// import { RouteRecordRaw } from "vue-router";
// // import { ElNotification } from "element-plus";
// import { useUserStore } from "@/stores/modules/user";
// import { useAuthStore } from "@/stores/modules/auth";
// import { useUploadUrlStore } from "@/stores/modules/uploadurls";
// // import { useGlobalStore } from "@/stores/modules/global";
// // 引入 views 文件夹下所有 vue 文件
// const modules = import.meta.glob("@/views/**/*.vue");

// /**
//  * @description 初始化动态路由
//  */
// export const initDynamicRouter = async (val = null) => {
//   const userStore = useUserStore();
//   const authStore = useAuthStore();
//   const uploadUrlStore = useUploadUrlStore();
//   try {
//     // 1.获取菜单列表 && 按钮权限列表
//     await authStore.getRoleMenusList(val);
//     // 文件上传路径
//     await uploadUrlStore.uploadUrlInit();
//     // await authStore.getAuthButtonList();

//     // 2.判断当前用户有没有菜单权限
//     if (!authStore.authMenuListGet.length || !authStore.getTokenStatus) {
//       // ElNotification({
//       //   title: "无权限访问",
//       //   message: "当前账号无任何菜单权限，请联系系统管理员！",
//       //   type: "warning",
//       //   duration: 3000
//       // });
//       userStore.setToken("");
//       // router.replace(LOGIN_URL);
//       // return Promise.reject("No permission");
//     }
//     // const menusList = authStore.menusList.filter(el => el.path == useGlobalStore().redirectGo);
//     // console.log(authStore.menusList, useGlobalStore().redirectGo);
//     // token过期
//     // if (!authStore.getTokenStatus) {
//     //   userStore.setToken("");
//     //   // router.replace(LOGIN_URL);
//     //   // return userStore.logout();
//     //   // return Promise.reject("No permission");
//     // }

//     // 3.添加动态路由
//     authStore.flatMenuListGet.forEach((item: any) => {
//       // debugger;
//       item.children && delete item.children;
//       if (item.component && typeof item.component == "string") {
//         item.component = modules["/src/views" + item.component + ".vue"];
//       }
//       if (item.meta.isFull) {
//         router.addRoute(item as unknown as RouteRecordRaw);
//       } else {
//         router.addRoute(item.meta.routing_prefix ? item.meta.routing_prefix : "layout", item as unknown as RouteRecordRaw);
//       }
//       if (item.meta.permission_verification === false) {
//         ROUTER_WHITE_LIST.push(item.path);
//       }
//     });
//   } catch (error) {
//     // 当按钮 || 菜单请求出错时，重定向到登陆页
//     userStore.setToken("");
//     // router.replace(LOGIN_URL);
//     return Promise.reject(error);
//   }
// };

// import router from "@/routers/index";
// import { ROUTER_WHITE_LIST } from "@/config";
// import { RouteRecordRaw } from "vue-router";
// import { ElNotification } from "element-plus";
// import { useUserStore } from "@/stores/modules/user";
// import { useAuthStore } from "@/stores/modules/auth";
// import { useUploadUrlStore } from "@/stores/modules/uploadurls";
// import { ElMessage } from "element-plus";
// import { getViewportWidth } from "@/utils";
// // import { useDesignTypeStore } from "@/stores/modules/designtype";
// // import { useDesignLevelStore } from "@/stores/modules/designlevel";
// // import { useTermStore } from "@/stores/modules/Termlist";

// // 引入 views 文件夹下所有 vue 文件
// const modules = import.meta.glob("@/views/**/*.vue");
// const viewportWidth = getViewportWidth();
// /**
//  * @description 初始化动态路由
//  */
// export const initDynamicRouter = async (val = null) => {
//   const userStore = useUserStore();
//   const authStore = useAuthStore();
//   const uploadUrlStore = useUploadUrlStore();
//   // const typeStore = useDesignTypeStore();
//   // const levelStore = useDesignLevelStore();
//   // const TermStore = useTermStore();
//   try {
//     // 1.获取菜单列表 && 按钮权限列表
//     await authStore.getRoleMenusList(val);
//     // 文件上传路径
//     await uploadUrlStore.uploadUrlInit();
//     // await authStore.getAuthMenuList();
//     //await authStore.getAuthButtonList();
//     // if (userStore.token && authStore.getTokenStatus) {
//     //   // 设计类型
//     //   await typeStore.getDesignType({ limit: 0, v_order: "asc", v_order_field: "order" });
//     //   // 设计等级
//     //   if (!userStore.userInfo["designerdata"]) await levelStore.getDesignLevel({ limit: 0, tag_type: "4" });
//     //   // 快捷语
//     //   await TermStore.getTermlist();
//     // }

//     // 2.判断当前用户有没有菜单权限
//     if (authStore.getTokenStatus == true && !authStore.authMenuListGet.length) {
//       ElNotification({
//         title: "无权限访问",
//         message: "当前账号无任何菜单权限，请联系系统管理员！",
//         type: "warning",
//         duration: 3000
//       });
//       if (navigator.userAgent.indexOf("wxwork") !== -1 && viewportWidth < 800) return router.push("/403");
//       // userStore.setToken("");
//       // router.replace("/403");
//       userStore.logout();
//       return Promise.reject("No permission");
//     }

//     // 3.添加动态路由
//     authStore.flatMenuListGet.forEach(item => {
//       item.children && delete item.children;
//       if (item.component && typeof item.component == "string") {
//         item.component = modules["/src/views" + item.component + ".vue"];
//       }
//       if (item.meta.isFull) {
//         router.addRoute(item as unknown as RouteRecordRaw);
//       } else {
//         router.addRoute(item.meta.routing_prefix ? item.meta.routing_prefix : "layout", item as unknown as RouteRecordRaw);
//       }
//       if (item.meta.permission_verification === false) {
//         ROUTER_WHITE_LIST.push(item.path);
//       }
//     });
//   } catch (error) {
//     // 当按钮 || 菜单请求出错时，重定向到登录页
//     if (error.response.status === 500) {
//       // router.replace({
//       //   path: "/500"
//       // });
//       ElMessage.error(`菜单请求出错时+ ${error}`);
//     }
//     router.replace({
//       path: "/500",
//       query: { msg: "请求出错" }
//     });
//     // userStore.setToken("");
//     // router.replace(HOME_URL);
//     // userStore.logout();
//     return Promise.reject(error);
//   }
// };

import router from "@/routers/index";
import { ROUTER_WHITE_LIST } from "@/config";
import { RouteRecordRaw } from "vue-router";
import { ElNotification, ElMessage } from "element-plus";
// import { useUserStore } from "@/stores/modules/user";
import { useAuthStore } from "@/stores/modules/auth";
import { useUploadUrlStore } from "@/stores/modules/uploadurls";
import { getViewportWidth } from "@/utils";

// 动态加载 views 下的所有 .vue 页面
const modules = import.meta.glob("@/views/**/*.vue");
const viewportWidth = getViewportWidth();

/**
 * @description 初始化动态路由
 */
export const initDynamicRouter = async (params: null | Record<string, any> = null) => {
  // const userStore = useUserStore();
  const authStore = useAuthStore();
  const uploadUrlStore = useUploadUrlStore();

  try {
    // Step 1: 获取菜单权限、按钮权限、上传路径等
    await Promise.all([authStore.getRoleMenusList(params), uploadUrlStore.uploadUrlInit()]);

    // Step 2: 判断是否有菜单权限
    if (authStore.getTokenStatus && !authStore.authMenuListGet.length) {
      ElNotification({
        title: "无权限访问",
        message: "当前账号无任何菜单权限，请联系系统管理员！",
        type: "warning",
        duration: 3000
      });

      // userStore.logout();
      if (navigator.userAgent.includes("wxwork") && viewportWidth < 800) {
        await router.replace("/403");
      }

      throw new Error("无任何菜单权限");
    }

    // Step 3: 添加动态路由
    for (const item of authStore.flatMenuListGet) {
      // 去除 children，防止重复添加
      if (item.children) delete item.children;

      // 动态加载组件
      if (item.component && typeof item.component === "string") {
        const path = `/src/views${item.component}.vue`;
        item.component = modules[path];
        if (!item.component) {
          console.warn(`[initDynamicRouter] 组件路径未找到：${path}`);
        }
      }

      // 添加路由
      if (item.meta?.isFull) {
        router.addRoute(item as unknown as RouteRecordRaw);
      } else {
        const parent = item.meta?.routing_prefix || "layout";
        router.addRoute(parent, item as unknown as RouteRecordRaw);
      }

      // 动态加入白名单（不验证权限的页面）
      if (item.meta?.permission_verification === false) {
        ROUTER_WHITE_LIST.push(item.path);
      }
    }
  } catch (error: any) {
    const errMsg = error?.message || error?.response?.data?.message || "未知错误";

    // 判断是否是 500 错误
    if (error?.response?.status === 500) {
      ElMessage.error(`服务器错误：${errMsg}`);
    }

    // 跳转到错误页面
    await router.replace({
      path: "/500",
      query: { msg: "请求出错" }
    });

    throw error;
  }
};
